var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntraverseLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 760,
    height: 139,
    viewBox: "0 0 760 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269.406 84.5684C274.884 82.189 279.115 78.7235 282.099 74.1721C285.083 69.6207 286.574 64.1607 286.572 57.7919C286.572 51.5058 285.081 46.0659 282.099 41.4722C279.117 36.8785 274.886 33.3526 269.406 30.8946C263.924 28.4365 257.396 27.2075 249.822 27.2075H213.194V111.828H232.898V88.1346H249.822C250.125 88.1346 250.397 88.1346 250.684 88.1346L267.109 111.838H288.144L269.288 84.6379L269.406 84.5684ZM262.274 46.9726C265.336 49.5112 266.868 53.1176 266.868 57.7919C266.868 62.4662 265.336 66.0928 262.274 68.6718C259.209 71.2527 254.696 72.5422 248.735 72.5402H232.898V43.1646H248.735C254.698 43.1646 259.211 44.4299 262.274 46.9605V46.9726Z",
    fill: "url(#paint0_linear_18675_304)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M584.016 84.5684C589.497 82.189 593.728 78.7235 596.71 74.1721C599.691 69.6207 601.182 64.1607 601.182 57.7919C601.182 51.5058 599.691 46.0659 596.71 41.4722C593.728 36.8785 589.497 33.3526 584.016 30.8946C578.534 28.4386 572.006 27.2095 564.433 27.2075H527.804V111.828H547.509V88.1346H564.433C564.735 88.1346 565.01 88.1346 565.297 88.1346L581.72 111.838H602.754L583.899 84.6379L584.016 84.5684ZM576.884 46.9726C579.947 49.5112 581.478 53.1176 581.478 57.7919C581.478 62.4662 579.947 66.0928 576.884 68.6718C573.82 71.2487 569.307 72.5382 563.345 72.5402H547.509V43.1646H563.345C569.309 43.1646 573.822 44.4309 576.884 46.9635V46.9726Z",
    fill: "url(#paint1_linear_18675_304)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.33 42.9449H155.409V111.609H174.992V42.9449H202.071V26.9878H128.33V42.9449Z",
    fill: "url(#paint2_linear_18675_304)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M433.025 26.9878H413.56L386.106 88.6644L396.351 111.609H396.397L433.025 26.9878Z",
    fill: "url(#paint3_linear_18675_304)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M466.448 76.3097H505.737V60.9571H466.448V42.7031H510.935V26.9878H446.986V111.609H512.506V95.8934H466.448V76.3097Z",
    fill: "url(#paint4_linear_18675_304)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M316.31 0L349.101 78.6068H322.877L329.399 62.9217L320.363 41.2074L299.437 88.308L309.132 111.609H309.151L316.694 93.4759H355.305L374.127 138.6H393.569L335.776 0H316.31Z",
    fill: "url(#paint5_linear_18675_304)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4709 26.9878V78.3255L56.4022 26.9878H40.2034V36.5681L61.8059 63.0272L101.614 111.609H117.813V26.9878H98.4709Z",
    fill: "url(#paint6_linear_18675_304)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2034 55.0327V111.608H59.5453V78.7266L40.2034 55.0327Z",
    fill: "url(#paint7_linear_18675_304)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.554688 26.9883H20.2593V111.519L0.554688 87.4363V26.9883Z",
    fill: "url(#paint8_linear_18675_304)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M670.867 68.8785C667.854 67.0946 664.651 65.6551 661.317 64.587C657.862 63.4604 654.352 62.5122 650.8 61.7462C647.252 60.9786 644.028 60.213 641.129 59.4493C638.229 58.6857 635.892 57.6179 634.117 56.2458C633.268 55.6212 632.582 54.8001 632.119 53.8527C631.656 52.9054 631.429 51.86 631.458 50.8059C631.449 49.0574 632.023 47.3558 633.09 45.9704C634.178 44.5198 635.89 43.3714 638.227 42.5252C640.565 41.679 643.667 41.2558 647.536 41.2558C651.459 41.286 655.361 41.8348 659.141 42.8878C661.721 43.5916 664.236 44.5033 666.664 45.6129L676.981 33.0035C673.124 30.6014 668.607 28.7585 663.432 27.4747C658.272 26.1894 652.974 25.5399 647.657 25.5405C639.678 25.5405 633.049 26.7293 627.771 29.1067C622.492 31.4841 618.563 34.6675 615.984 38.6568C613.421 42.5926 612.075 47.1971 612.116 51.8939C612.116 56.3264 612.982 60.0135 614.715 62.9551C616.426 65.8759 618.835 68.3265 621.726 70.0874C624.754 71.9397 628.003 73.4019 631.397 74.4393C634.903 75.5273 638.389 76.4541 641.854 77.2197C645.319 77.9854 648.523 78.7913 651.465 79.6375C654.404 80.4837 656.761 81.5717 658.536 82.9014C659.387 83.5112 660.074 84.3208 660.538 85.259C661.002 86.1971 661.228 87.2349 661.196 88.2809C661.219 89.987 660.617 91.6426 659.503 92.9351C658.373 94.2648 656.62 95.3327 654.245 96.1386C651.869 96.9445 648.747 97.3474 644.876 97.3474C639.739 97.3368 634.637 96.5 629.765 94.8692C626.326 93.7325 623.231 92.3765 620.481 90.801L610.333 103.203L610.302 103.271C614.088 106.172 619.105 108.53 625.353 110.343C631.699 112.17 638.272 113.086 644.876 113.063C652.855 113.063 659.503 111.854 664.823 109.436C670.142 107.018 674.111 103.835 676.73 99.8861C679.321 96.0273 680.69 91.478 680.659 86.8303C680.659 82.4783 679.752 78.8316 677.939 75.89C676.189 73.0103 673.761 70.603 670.867 68.8785Z",
    fill: "url(#paint9_linear_18675_304)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M713.536 76.3102V95.8939H759.445L746.587 111.609H694.077V26.9883H758.023V42.7036H713.536V60.9575H752.825V76.3102H713.536Z",
    fill: "url(#paint10_linear_18675_304)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18675_304",
    x1: 217.04,
    y1: 107.494,
    x2: 296.963,
    y2: 36.7127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18675_304",
    x1: 531.651,
    y1: 107.494,
    x2: 611.574,
    y2: 36.7127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18675_304",
    x1: 132.115,
    y1: 107.266,
    x2: 211.863,
    y2: 37.7707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18675_304",
    x1: 388.514,
    y1: 107.266,
    x2: 456.796,
    y2: 69.4058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18675_304",
    x1: 450.348,
    y1: 107.266,
    x2: 528.289,
    y2: 46.9174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18675_304",
    x1: 304.268,
    y1: 131.487,
    x2: 426.838,
    y2: 48.2423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18675_304",
    x1: 44.1865,
    y1: 107.266,
    x2: 124.391,
    y2: 33.7067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_18675_304",
    x1: 41.1961,
    y1: 108.704,
    x2: 74.1469,
    y2: 97.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_18675_304",
    x1: 1.56599,
    y1: 107.181,
    x2: 37.1259,
    y2: 98.8918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_18675_304",
    x1: 613.913,
    y1: 108.571,
    x2: 695.233,
    y2: 43.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_18675_304",
    x1: 697.432,
    y1: 107.266,
    x2: 775.327,
    y2: 47.0934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntraverseLogo);
export default __webpack_public_path__ + "static/media/IntraverseLogo.43cb501ba5895683a074ad1f808f4ad2.svg";
export { ForwardRef as ReactComponent };